module.exports = __webpack_public_path__ + "img/tt.b4214bc9.svg";